// 猫眼APP
// 点评APP
export default {
  appName: 'maoyan',
  useKNB: true,
  sellChannel: 5,
  theme: 'maoyan'
};